import {CALL_API} from 'redux-api-middleware';
import {
  SAVE_LOCATION_SITE,
  SAVE_LOCATION_SITE_SUCCESS,
  SAVE_LOCATION_SITE_FAILURE,
} from 'common/types';
import {ENDPOINT_LOCATION} from 'common/endpoints';
import goStore from 'go/store';
import {getInfo} from 'common/storeUtils';
import _ from 'lodash';
import {commonJwtHeader} from 'common/utils';

export default {
  updateProjectSiteDetails: (token, payload) => {
    // TODO remove OpenAPI toggle code
    const {baseUrl: endPointBase} = getInfo(goStore.store.getState(), ENDPOINT_LOCATION);

    const entityId = _.get(payload, 'entityId'); // TODO, look into if this works for subapplication review still, clean this up maybe
    const entityType = _.get(payload, 'entityType');
    const endpointToUse = `${endPointBase}/entityType/${entityType}/entityId/${entityId}/siteInventory`;

    return {
      [CALL_API]: {
        endpoint: endpointToUse,
        headers: commonJwtHeader(),
        method: 'PUT',
        body: JSON.stringify(payload),
        types: [
          SAVE_LOCATION_SITE,
          SAVE_LOCATION_SITE_SUCCESS,
          SAVE_LOCATION_SITE_FAILURE,
        ],
      },
    };
  },
};
